import { CanDeactivateFn } from '@angular/router';
import { ScannerResultsComponent } from '../scanner-results.component';

export const scannerResultsDeactivateGuard: CanDeactivateFn<ScannerResultsComponent> = (
  component
) => component.confirmLeave();
